module.exports = __webpack_public_path__ + "static/img/drem_case.93e5437.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/drem_case.jpg
// module id = 9uN3
// module chunks = 1